import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToolsService } from 'app/_services/tools.service';
import { Category } from '../category';

@Component({
    selector: 'app-edit-category-dialog',
    templateUrl: './edit-category-dialog.component.html',
    styleUrls: ['./edit-category-dialog.component.scss'],
})
export class EditCategoryDialogComponent implements OnInit {
    title = 'Category Editor';
    category: Category;
    categoryNames: string[];
    categoryEditorForm: FormGroup;
    isCategoryUpdated: boolean;
    eventName: string;

    // Getters for form validation error messages
    get Name(): AbstractControl {
        return this.categoryEditorForm.controls.Name;
    }

    constructor(
        private dialogRef: MatDialogRef<EditCategoryDialogComponent>,
        private formBuilder: FormBuilder,
        private toolsService: ToolsService,
        @Inject(MAT_DIALOG_DATA) public data: { category: Category; categoryNames: string[]; title: string }
    ) {
        this.category = data.category;
        this.categoryNames = data.categoryNames;
    }

    ngOnInit(): void {
        this.categoryEditorForm = this.formBuilder.group({
            Name: [this.category.name, [Validators.required, isCategoryNameTaken(this.category.name, this.categoryNames)]],
            Active: [this.category.active],
        });

        this.title = this.data.title;
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues: any): void {
        this.categoryEditorForm.markAllAsTouched();

        if (this.categoryEditorForm.valid) {
            const today = this.toolsService.toISOLocal(new Date());

            this.category.name = formValues.Name;
            this.category.active = formValues.Active;

            // If a category has no value for DateCreated, then we assume its a new category.
            // Set the DateCreated and DateUpdated properties to be the date/time they were created.
            if (!this.category.dateCreated) {
                this.category.dateCreated = today;
            }

            this.category.dateUpdated = today;

            this.dialogRef.close(this.category);
            this.categoryEditorForm.reset();
        }
    }
}

/* Validation function to see if the inputted CategoryName already exists. If so, the field will become invalid.
 * This error will NOT occurr if, while editing an existing CategoryName, the user reverts changes to match the
 * original name provide to the form prior to saving.
 */
function isCategoryNameTaken(name: string, categoryNames: string[]): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        const isNameTaken = categoryNames.some((value) => value === control.value);
        const error = isNameTaken && control.dirty && control.value !== name ? { isNameTaken: true } : null;
        return error;
    };
}
